import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import socials from "data/socials";

const ContactInfoOne = () => {
    return (
        <div className="bk_contact_classic bg_color--black ptb--160 ptb-md--80 ptb-sm--80 white">
            <Container>
                <Row>
                    {data.map(item=>(
                        <Col key={item.id} md={6} lg={4} className="wow move-up" >
                            <div className="classic-address text-center">
                                <h4 className="heading heading-h4 white">{item.title}</h4>
                                <div className="desc mt--15">
                                    <p className="bk_pra line-height-2-22" dangerouslySetInnerHTML={{__html: item.content}}/>
                                </div>
                            </div>
                        </Col>
                    ))}
                    <Col md={6} lg={4} className="wow move-up">
                        <div className="classic-address text-center">
                            <h4 className="heading heading-h4 white">Síguenos</h4>
                            <div className="desc mt--15">
                                <ul className="social-icon icon-solid-rounded icon-size-medium text-center move-up wow">
                                    {socials.map((social, i) => (
                                        <li className={social.media} key={i}>
                                            <a key={social.id} href={`https://${social.media}.com/${social.username}`}>
                                                <i className={`fa fa-${social.media}`}/>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const data = [
    {
        id: 1,
        title: "Visítanos",
        content: "Arkadia Shopping Mall, Nivel 2 Local 230 Boulevard Los Próceres, 26-21, Zona 10"
    },
    {
        id:2,
        title:"Contáctanos",
        content: "pentcloud@pentcloud.com <br> (+502) 2214 3232"
    }
]

export default ContactInfoOne;
